module.exports = __webpack_public_path__ + "cafb6a6790be5cd5a6c8e14a0c8eb229.svg";